export const useApiSecret = () => useState('apiSecret', () => null)